import BaseLayer from "./BaseLayer";
import {plotFftFourDTextUnit, transformFFTFourDData} from "../utils/map_utils";

class FFTFourDText extends BaseLayer {
    id = "fft4dText";
    label = "FFT 4D Text";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {normBlurValsFourd, textColor, textSize} = this.props;
        let dataArray = transformFFTFourDData(normBlurValsFourd, this.props.slide);
        let margin = 2 / 10;
        let sizeOfMarker = 0.3;
        for (let fftVals in dataArray[0]) {
            let x = parseInt(fftVals.split('y')[0].split('x')[1]);
            let y = parseInt(fftVals.split('y')[1].split('.' + this.props.slide.img_type)[0]);
            plotFftFourDTextUnit(dataArray[0][fftVals], this.props.slide, x, y, margin, sizeOfMarker,
                this.layer.getSource(), textColor, textSize);
        }
        resolve();
    });
}

export default FFTFourDText;
